// Copyright 2024 - MinIO, Inc. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { ingressRpc } from "../../../api";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../../systemSlice";
import { errorToHandler } from "../../../api/error";
import { listIngressAsync } from "../ingressThunks";
import { AsyncResourceRequest } from "../../../common/common.types";

export const getIngressAsync = createAsyncThunk(
  "ingress/getIngressAsync",
  async (
    {
      siteID,
      namespace,
      resourceID,
    }: {
      siteID: string;
      namespace: string;
      resourceID: string;
    },
    { getState, rejectWithValue, dispatch },
  ) => {
    return ingressRpc.api
      .getIngress(siteID, namespace, resourceID)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(err);
      });
  },
);

export const deleteIngressAsync = createAsyncThunk(
  "ingress/deleteIngressAsync",
  async (
    req: AsyncResourceRequest,
    { getState, rejectWithValue, dispatch },
  ) => {
    return ingressRpc.api
      .deleteIngress(req.siteId, req.namespace, req.resourceId)
      .then((res) => {
        dispatch(setSnackBarMessage("Deleted Ingress successfully"));
        dispatch(listIngressAsync(req));
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(err);
      });
  },
);
